export default __webpack_public_path__ + "static/Final 2-8826cdd8016da9dd69a7641a34372fd3.png";